import { render } from "./CarTypeSet.vue?vue&type=template&id=d1c7893c&scoped=true&ts=true"
import script from "./CarTypeSet.vue?vue&type=script&lang=ts"
export * from "./CarTypeSet.vue?vue&type=script&lang=ts"

import "./CarTypeSet.vue?vue&type=style&index=0&id=d1c7893c&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c7893c"]])

export default __exports__